export function SearchParams(queryParams) {
  const self = this;
  this.queryParams = queryParams;

  this.get = function (name) {
    const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(self.queryParams);
    if (results == null) {
      return null;
    }

    return decodeURI(results[1]) || 0;
  };
}



// WEBPACK FOOTER //
// ./client/redesign/lib/utils.js